import type { FaireProductEntity } from "../../entity_types/product";

export const p_esvm9equu8: FaireProductEntity = {
  token: "p_esvm9equu8",
  type: "product",
  name: "Bubba Baby Blue Trucker Hat",
  brandToken: "b_szmga73tgk",
  brandName: "Knuckleheads Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/b0e6d6672dd1f5228b8270d59e0a1a9b02a363ebd72dc08dcf124ad7aac07014.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3f6d7c7496fc5254d284abfd97dfbea505931c32b8a0ace7f0132b5765ea8088.png",
    "https://cdn.faire.com/fastly/80be9fe630613ef9f720c136d69813803411031189ebeb91be7166f7ad9c6642.jpeg",
    "https://cdn.faire.com/fastly/33721220fa60af2561ee923aee60431a72dc68373f8c69d6233bf5315ada63bb.jpeg",
    "https://cdn.faire.com/fastly/20d2a7ff9375c58c2e7a5668bdf4390d6c3a99e130a67ebb16be874b88a41d1b.png",
    "https://cdn.faire.com/fastly/5ee1e72c9c8f623210f0ed998d3ed9d061ca6bf6e34ab78bec392eb3e5d27bc5.jpeg",
    "https://cdn.faire.com/fastly/ee704ef429c513512d01874f40e601ebe9a67e9cbe8d337194eb1c8f26276d41.jpeg",
    "https://cdn.faire.com/fastly/2b5678e71ff7e0b60ef221d84dbb28dd58983e4174c648d8a8327dd4f265f994.png",
    "https://cdn.faire.com/fastly/31f3de9639d24f76d2e0d806b0b605036c28f9b34172a3d39bbcc2a7e943836e.png",
    "https://cdn.faire.com/fastly/41e15a0632d9ce4888c8d378e20aa597316aeb9d2513d95b45998510c10c806c.png",
  ],
  priceDollars: 14.3,
  description:
    "The Bubba Kids Trucker Hat is a stylish and comfortable choice for outdoor play. Its breathable white mesh back and flat brim, along with its high-quality materials, provide extra protection from the sun's harmful UV rays. Plus, the Bubba patch adds a cool and unique touch. Perfect for a day of adventure! \n• Medium profile\n• Structured 5-panel\n• 70% Polyester 30% Wool\n• Bubba patch\n• Mesh back for breathability • Flat bill \n\nMore from Us: \n• Beanies • Shorts & Swim • Mechanic Jackets \nShipping & Processing Returns & Exchanges \n\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:17.710Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
